import React from 'react';
import {injectIntl} from "react-intl";
import {Modal} from "antd";
import SAInputNumber from "../../common/input/SAInputNumber";

class SetRentalsMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.date) {
      const {data = {}} = nextProps;

      this.setState({
        maxRentalCars: data.maxRentalCars || 0,
        maxRentalMotorbikes: data.maxRentalMotorbikes || 0,
        errors: {}
      });
    }
  };

  onInputValidate = () => {
    const {date, data: {currentRentalCars = 0, currentRentalMotorbikes = 0} = {}, hasMotorbike} = this.props;
    const errors = this.checkInputForErrors(hasMotorbike, currentRentalCars, currentRentalMotorbikes);
    this.setState({errors});

    if (Object.keys(errors).length === 0) {
      this.props.onModalClose();
      this.props.onModalDayChange(date, this.state.maxRentalCars, this.state.maxRentalMotorbikes);
    }
  };

  checkInputForErrors = (hasMotorbike, currentRentalCars, currentRentalMotorbikes) => {
    const errors = {};

    if (this.state.maxRentalCars === undefined) {
      errors['maxRentalCars'] = {message: 'error.not.null'}
    }
    if (hasMotorbike && this.state.maxRentalMotorbikes === undefined) {
      errors['maxRentalMotorbikes'] = {message: 'error.not.null'}
    }
    if (currentRentalCars > this.state.maxRentalCars) {
      errors['maxRentalCars'] = {message: 'error.greater.or.equal', args: {value: currentRentalCars}}
    }
    if (currentRentalMotorbikes > this.state.maxRentalMotorbikes) {
      errors['maxRentalMotorbikes'] = {message: 'error.greater.or.equal', args: {value: currentRentalMotorbikes}}
    }
    return errors;
  };

  onInputChange = (number, name) => {
    this.setState({[name]: number});
  };

  render() {
    const {intl:{formatMessage}, visible, hasMotorbike} = this.props;

    return (
      <div>
        <Modal title={formatMessage({id: 'section.rental-planning.modal.title'})}
               visible={visible} onOk={this.onInputValidate} onCancel={this.props.onModalClose}>

          <ul className="list">
            <li>
              <label>{formatMessage({id: 'rental-planning.maxRentalCars'})}</label>
              <SAInputNumber className={"right"} value={this.state.maxRentalCars} min={0}
                             onChange={(e) => this.onInputChange(e, 'maxRentalCars')}
                             error={this.state && this.state.errors && this.state.errors['maxRentalCars']}
              />
            </li>
            <br/>
            {hasMotorbike &&
              <li>
                <label>{formatMessage({id: 'rental-planning.maxRentalMotorbikes'})}</label>
                <SAInputNumber className={"right"} value={this.state.maxRentalMotorbikes} min={0}
                               onChange={(e) => this.onInputChange(e, 'maxRentalMotorbikes')}
                               error={this.state && this.state.errors && this.state.errors['maxRentalMotorbikes']}
                />
              </li>
            }
          </ul>
        </Modal>
      </div>
    )
  }
}

export default injectIntl(SetRentalsMenu);



// WEBPACK FOOTER //
// ./src/components/planning/management/SetRentalsMenu.js